import { render, staticRenderFns } from "./add-edit1.vue?vue&type=template&id=15b9a118&scoped=true"
import script from "./add-edit1.vue?vue&type=script&lang=js"
export * from "./add-edit1.vue?vue&type=script&lang=js"
import style0 from "./add-edit1.vue?vue&type=style&index=0&id=15b9a118&prod&lang=scss&scoped=true"
import style1 from "./add-edit1.vue?vue&type=style&index=1&id=15b9a118&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b9a118",
  null
  
)

export default component.exports